var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userData)?_c('div',[_c('vue-headful',{attrs:{"title":_vm.$t('editMyProfile')}}),_c('ContactEdit',{attrs:{"userData":_vm.userData,"uploadSettings":_vm.uploadSettings}}),(_vm.user.role && _vm.user.role.is_student)?_c('LinkSocialEdit',{attrs:{"userData":_vm.userData}}):_vm._e(),_c('div',{staticClass:"mobile_dummy"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }